<template>
  <div>

    <Drawer class="drawer_modal"
            width="700"
            v-model="productOrderShow.show">
      <productOrderDetail
        v-if="productOrderShow.show"
        :id="productOrderShow.id"
        :base_view_url="baseProductOrder"
        :item_type="productOrderShow.type"
        @click_cancel="productOrderShow.show = false"
      ></productOrderDetail>
    </Drawer>

        <Drawer class="drawer_modal"
                width="700"
                v-model="moneyOrderShow.show">
          <moneyOrderDetail
            v-if="moneyOrderShow.show"
            :id="moneyOrderShow.id"
            :base_view_url="baseMoneyOrder"
            :item_type="moneyOrderShow.type"
            @click_cancel="moneyOrderShow.show = false"
          ></moneyOrderDetail>
        </Drawer>

  </div>
</template>


<script>
    import {base_url} from "../../http.js";
    import productOrderDetail from "@/apps/product_order/productOrderDetail.vue";
    import moneyOrderDetail from "@/apps/money_order/moneyOrderDetail.vue";

    export default {
        name: "drawersCommonDocs",
        components: {
            productOrderDetail,
            moneyOrderDetail
        },

        props: ['item'],

        data() {
            return{
               baseProductOrder: base_url + "/product_orders/",
               baseMoneyOrder: base_url + "/money_orders/",

                drawerItem: {
                    show: false,
                    id: null,
                    type: null
                },
            }
        },

        computed: {
            productOrderShow() {
                if(this.item.type === 'product_order') return this.item;
                else return this.drawerItem
            },
            moneyOrderShow() {
                if(this.item.type === 'money_order') return this.item;
                else return this.drawerItem
            }
        }
    }



</script>



// WEBPACK FOOTER //
// src/apps/partial/drawers_docs.vue